import apiClient from '../apiClient';

/**
 * Save or update a salesperson monthly target
 */
export const saveSalesTarget = async (payload) => {
    try {
        const response = await apiClient.post('/sales-targets', payload);
        return response.data;
    } catch (error) {
        console.error('Error saving sales target:', error);
        throw error;
    }
};

/**
 * Get targets progress for all salespeople
 */
export const getSalesTargetsProgress = async (month) => {
    try {
        const url = month ? `/sales-targets/progress?month=${month}` : '/sales-targets/progress';
        const response = await apiClient.get(url);
        return response.data;
    } catch (error) {
        console.error('Error fetching sales targets progress:', error);
        throw error;
    }
};

/**
 * Get personal target progress for the logged-in salesperson
 */
export const getMySalesTargetProgress = async (month) => {
    try {
        const url = month ? `/sales-targets/my-progress?month=${month}` : '/sales-targets/my-progress';
        const response = await apiClient.get(url);
        return response.data;
    } catch (error) {
        console.error('Error fetching personal sales target progress:', error);
        throw error;
    }
};

/**
 * Download sales targets progress PDF from the backend
 */
export const downloadSalesTargetsPdf = async (month) => {
    try {
        const url = month ? `/sales-targets/pdf?month=${month}` : '/sales-targets/pdf';
        const response = await apiClient.get(url, {
            responseType: 'blob'
        });
        const blob = new Blob([response.data], { type: 'application/pdf' });
        const urlBlob = window.URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = urlBlob;
        const formattedMonth = month ? month.replace('-', '_') : 'current';
        link.setAttribute('download', `Sales_Targets_Report_${formattedMonth}.pdf`);
        document.body.appendChild(link);
        link.click();
        link.remove();
        window.URL.revokeObjectURL(urlBlob);
    } catch (error) {
        console.error('Error downloading sales targets PDF:', error);
        throw error;
    }
};
